@for (accor of sections; track accor; let isFirstOuter = $first) {
  <accordion [openByDefault]="isFirstOuter">
    <div header>
      @if (accor.IconSvgContent) {
        <icon [svg]="accor.IconSvgContent"></icon>
      }
      <h2 [innerHTML]="accor.Title"></h2>
      @if (accor.IsFavoritable) {
        <favorite-btn (toggle)="handleFavoriteToggle($event, accor.Id)" [isActive]="accor.IsFavorited"></favorite-btn>
      }
    </div>
    <div body>
      @for (item of accor.TextItems; track item) {
        @if (item.Paragraph) {
          <p [innerHTML]="item.Paragraph"></p>
        }
        @if (item.BulletListItems.length) {
          <ul class="with-bullets">
            @for (blItem of item.BulletListItems; track blItem) {
              <li [innerHTML]="blItem"></li>
            }
          </ul>
        }
      }
      @for (subAccor of accor.SubAccordions; track subAccor; let isFirstInner = $first) {
        <accordion [openByDefault]="isFirstInner">
          <div header>
            <h2 [innerHTML]="subAccor.Title"></h2>
          </div>
          <div body>
            @for (subItem of subAccor.TextItems; track subItem) {
              @if (subItem.Paragraph) {
                <p [innerHTML]="subItem.Paragraph"></p>
              }
              @if (subItem.BulletListItems.length) {
                <ul class="with-bullets">
                  @for (blItem of subItem.BulletListItems; track blItem) {
                    <li [innerHTML]="blItem"></li>
                  }
                </ul>
              }
            }
          </div>
        </accordion>
      }
    </div>
  </accordion>
}